<ng-container *transloco="let t">
  <div class="flex items-center gap-2">
    @if (!isReadOnly()) {
      <ISelectMenu
        [class.hidden]="strategy().primeDayBoost === undefined"
        [value]="selectedBoost()"
        (valueChange)="setIntensity($event)"
      >
        <ISelectTrigger>
          <ISelectValue>
            <div *iSelectValue="let value">{{ value | boostIntensityLabel }}</div>
          </ISelectValue>
        </ISelectTrigger>
        <ISelectContent>
          @for (intensity of boostIntensities; track intensity) {
            <ISelectOption [value]="intensity">
              {{ intensity | boostIntensityLabel }}
            </ISelectOption>
          }
        </ISelectContent>
      </ISelectMenu>
    } @else {
      <span class="text-sm text-gray-500">{{ selectedBoost() | boostIntensityLabel }}</span>
    }
    @if (isStrategyEligible() && strategy().primeDayBoost === undefined) {
      <span class="text-sm text-gray-500">Promo days boost not activated</span>
    } @else if (strategy().primeDayBoost !== undefined) {
      <IIcon
        name="infoCircle"
        class="text-sm"
        [iTooltip]="
          t('strategy-boost-table.statey_boost', [
            strategy().acosTarget | percent,
            'Promo days',
            config().primeDayPeriod,
            primeDayBoost() | percent,
            config().primeDayAfterPeriod,
            primeDayDecrease() | percent,
            config().primeDayOverDate,
            strategy().acosTarget | percent,
          ])
        "
        iTooltipWidth="250"
      />
    }
  </div>
</ng-container>
